import { searchCustomer } from "src/apis/customerApi";
import useUiuxStore from "src/store/useUiuxStore";
import { defaultWMS2091_R01Filter, useWMS2091_R01Store } from "src/containers/mes/WMS/WMS2091_R01/Store_WMS2091_R01";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";

export const SearchSection_WMS2091_R01 = () => {
	const {
		WMS2091_R01Filter, setWMS2091_R01Filter,
	} = useWMS2091_R01Store();
	const { setCodeSearchModalProps } = useUiuxStore();
	const { yesNoList } = useCommonCodeStore();

	const custInfoHandleFoucsId = 'infoCustInput_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find(value => value.customCd === searchText);
			}
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: WMS2091_R01Filter,
		setEditData: setWMS2091_R01Filter,
		defaultData: defaultWMS2091_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'WMS2091_R01_search'
	});

	return (
		<SearchSectionForm>
			<SearchCodeModalForm
				label="거래처"
				value={WMS2091_R01Filter.customCd}
				valueLabel={WMS2091_R01Filter.customNm}
				handleFoucsId={custInfoHandleFoucsId}
				onChange={getFieldHandlers('customCd').onChange}
				onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
				onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
			/>

			<SearchDropDownForm
				label="Lot라벨자동출력"
				value={WMS2091_R01Filter.labelPrintAuto}
				onChangeItem={(item) => setWMS2091_R01Filter({ labelPrintAuto: item?.minorCd || 'N' })}
				optionList={yesNoList}
				initLabelLess={true}
				wrapperOption={{
					wrapperStyle: "w-[250px] min-w-[250px] mr-[10px]",
					titleStyle: "h-[24px] flex items-center truncate shrink-0 w-[100px] min-w-[100px]",
					selectStyle: "w-[120px] min-w-[120px] ",
				}}
			/>
		</SearchSectionForm>
	);
};

export default SearchSection_WMS2091_R01;
